import React from 'react';
import { Button } from '../Button';
import { Badge } from '../Badge';
import { Input } from '../Input';
import { Separator } from '../Separator';
export function RoiCalculator() {
  return <section className="w-full border-b border-gray-200 bg-white px-4 sm:px-6 lg:px-12 py-12 sm:py-20 lg:py-24" data-id="element-260">
      <div className="mx-auto max-w-[1280px]" data-id="element-261">
        {/* Header */}
        <div className="flex flex-col items-center gap-4 text-center max-w-2xl mx-auto mb-10 sm:mb-14" data-id="element-262">
          <span className="inline-flex items-center px-3 py-1 rounded-full bg-orange-brand-500 text-white uppercase tracking-[0.15em] text-[11px] font-semibold" data-id="element-263">
            ROI Calculator
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-gray-900 tracking-tight leading-[1.1]" data-id="element-264">
            See what speed is worth to you.
          </h2>
          <p className="text-base text-gray-600 leading-relaxed" data-id="element-265">
            Enter your numbers below. Watch what happens when every lead gets a
            response in under 60 seconds.
          </p>
        </div>

        {/* 2-column */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-stretch" data-id="element-266">
          {/* Input card */}
          <div className="border border-gray-300 rounded-2xl bg-white p-6 sm:p-8 flex flex-col gap-6" data-id="element-267">
            <div data-id="element-268">
              <h3 className="text-xl font-semibold text-gray-900" data-id="element-269">
                Your Business Today
              </h3>
              <p className="text-sm text-gray-500 mt-1" data-id="element-270">
                Adjust the defaults to match your business
              </p>
            </div>

            <div className="flex flex-col gap-5 flex-1" data-id="element-271">
              <Input label="Monthly Leads" placeholder="e.g. 100" helperText="How many inbound leads you receive per month" data-id="element-272" />
              <Input label="Conversion Rate" placeholder="e.g. 5%" helperText="Your current close rate on inbound leads" data-id="element-273" />
              <Input label="Average Sale Value" placeholder="e.g. $2,500" helperText="The average revenue per closed deal" data-id="element-274" />
            </div>

            <Button variant="primary" size="large" className="w-full !bg-navy-500 !border-navy-500 hover:!bg-navy-800 hover:!border-navy-800" rightIcon={<span aria-hidden data-id="element-276">→</span>} data-id="element-275">
              Calculate My ROI
            </Button>
          </div>

          {/* Results card — dark navy */}
          <div className="border border-navy-800 rounded-2xl bg-navy-500 text-white p-6 sm:p-8 flex flex-col gap-6" data-id="element-277">
            <div className="text-[11px] uppercase tracking-[0.15em] text-gray-400 font-semibold" data-id="element-278">
              Your Potential ROI
            </div>

            <div className="text-sm text-gray-400 font-mono" data-id="element-279">
              Today: $25,000/mo
            </div>

            <Separator color="#14315A" data-id="element-280" />

            <div data-id="element-281">
              <div className="text-[11px] uppercase tracking-[0.15em] text-gray-400 font-semibold mb-2" data-id="element-282">
                With 60-Second Response Times
              </div>
              <div className="flex items-baseline gap-2 font-mono flex-wrap" data-id="element-283">
                <span className="text-4xl sm:text-5xl font-bold leading-none text-orange-brand-500" data-id="element-284">
                  $87,500
                </span>
                <span className="text-sm text-gray-400" data-id="element-285">/month</span>
              </div>
              <div className="text-sm text-gray-300 mt-3 leading-relaxed" data-id="element-286">
                8× more revenue —{' '}
                <span className="italic text-gray-500" data-id="element-287">
                  [research citation]
                </span>
              </div>
            </div>

            {/* Delta callout */}
            <div className="border border-orange-brand-500/40 rounded-xl bg-navy-800 p-5 flex flex-col gap-1" data-id="element-288">
              <div className="text-[11px] uppercase tracking-[0.15em] text-orange-brand-500 font-semibold" data-id="element-289">
                Additional Monthly Revenue
              </div>
              <div className="text-3xl sm:text-4xl font-mono font-bold leading-none mt-1 text-white" data-id="element-290">
                +$62,500
              </div>
            </div>

            <div className="flex-1" data-id="element-291" />

            <div className="border-l-2 border-orange-brand-500 pl-3 text-sm font-semibold text-white leading-snug" data-id="element-292">
              Every 5-minute delay drops conversion rates by 80%
            </div>

            <Button variant="primary" size="large" className="w-full !bg-orange-brand-500 !border-orange-brand-500 hover:!bg-orange-brand-600 hover:!border-orange-brand-600" rightIcon={<span aria-hidden data-id="element-294">→</span>} data-id="element-293">
              Claim Your Extra $62,500/mo
            </Button>

            <div className="text-xs text-gray-400 text-center" data-id="element-295">
              No contracts · Setup in minutes · Cancel anytime
            </div>
          </div>
        </div>
      </div>
    </section>;
}